module.exports = __webpack_public_path__ + "img/MEDICO.6eecdccf.jpg";